import securityMeta from '@/router/security/securityMeta.js'
import profile from '@/router/security/profile/index.js'
import { checkRole } from '@/utils/utils.js'
import { Alert } from '@/extension/Alert/Alert.js'

export default [
  {
    path: '/security/users/:id',
    name: 'security-user',
    redirect: { name: 'security-profile-info' },
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Profile/SecurityProfileUserView.vue'),
    props: {
      title: 'Профиль',
    },
    children: [...profile],
    async beforeEnter(to, from, next) {
      try {
        const candidate = await checkRole('security')
        if (candidate) {
          return next()
        } else {
          return next({ name: 'login' })
        }
      } catch (e) {
        await Alert.show('error', 'Что-то пошло не так')
      }
    },
  },
  {
    path: '/security/users/users-all',
    name: 'security-users-all',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersAllUsersView.vue'),
  },
  {
    path: '/security/users/members-tp',
    name: 'security-users-members-tp',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersMembersTPView.vue'),
  },
  {
    path: '/security/users/organizer',
    name: 'security-users-organizer',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersOrganizersView.vue'),
  },
  {
    path: '/security/users/security',
    name: 'security-users-security',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersSecurityView.vue'),
  },
  {
    path: '/security/users/admins',
    name: 'security-users-admins',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersAdminsView.vue'),
  },
  {
    path: '/security/users/journal',
    name: 'security-users-journal',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersJournalView.vue'),
  },
  {
    path: '/security/users/banned',
    name: 'security-users-banned',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Users/SecurityUsersBannedView.vue'),
  },
]
